import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          image={`url(${mobileHero}) top / cover no-repeat`}
          column
          alignCenter
        >
          <Header />
          <CFView textCenter w="100%">
            <CFView>
              <CFImage
                mt="40px"
                w="90%"
                src={mobileHeroText}
                alt="Woorinara Korean Restaurant hero text"
                zIndex={98}
              />
            </CFView>
            <CFView pulsate mt="370px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="680px"
          w="100%"
          image={`url(${hero}) top/ cover no-repeat`}
          zIndex={90}
          column
          justifyStart
          alignStart
        >
          <Header />
          <CFView column justifyCenter alignStart ml="100px" mt="110px">
            <CFImage
              w="550px"
              src={heroText}
              alt="Woorinara Korean Restaurant hero text"
              zIndex={98}
            />
            <CFView pulsate mt="85px" ml="20px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
